import { useState, useEffect, useCallback } from "react";
import { makeApiRequest, apiRoutes } from "constants/apiRoutes";
import { useAuth } from "utilities/auth";
import { useEffectiveCompanyId } from "hooks/useEffectiveCompanyId";

export function useCompany(companyId) {
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const auth = useAuth();
  const effectiveCompanyId = useEffectiveCompanyId();

  const fetchCompany = useCallback(async () => {
    if (!auth.user || !companyId) return;

    setLoading(true);
    setError(null);

    try {
      const response = await makeApiRequest(
        "get",
        apiRoutes.getCompany(companyId),
        auth.user,
        effectiveCompanyId
      );
      setCompany(response.data || null);
    } catch (err) {
      setError(err);
      setCompany(null);
    } finally {
      setLoading(false);
    }
  }, [effectiveCompanyId, companyId]);

  useEffect(() => {
    fetchCompany();
  }, [fetchCompany]);

  return { company, loading, error, refetch: fetchCompany };
}
